import { ClientFilterSpecBase } from "abweb/dto/generated/ds/ClientFilterSpecBase";
import { TSOGUtils } from "abweb/utils/json/TSOGUtils";
export class ClientFilterSpec extends ClientFilterSpecBase {
  static createClientFilterSpec(fieldDataType, fieldPath, filterType, filterValue) {
    const retVal = new ClientFilterSpec();
    if (fieldDataType != null && typeof fieldDataType !== "number")
      // i.e. DataFieldTypeEnum enum value
      {
        throw new Error(fieldDataType + ": neither null nor a DataFieldTypeEnum");
      }
    retVal.initClientFilterSpec(/*displayValue*/"", fieldDataType, fieldPath, filterType, filterValue);
    return retVal;
  }
  constructor() {
    super();
  }
  clone() {
    // Note of warning - Date fields are truncated to a midnight value when sent to the server, and are assumed to be
    // midnight when they are ingested. That means any Date objects that are not at midnight in this filter will be set
    // to midnight after the clone.
    const json = TSOGUtils.stringify(this);
    return TSOGUtils.parse(json, ClientFilterSpec);
  }
}
//# sourceMappingURL=ClientFilterSpec.js.map
